<template>
  <div class="d-flex styleHeader">
    <button class="buttonBack" type="button" v-if="canBack" @click="onBack">
      <!-- SVG Cross -->
      <svg v-if="isCross" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.9663 11.1996L8.43334 6.66667L12.9663 2.13371C13.4557 1.64432 13.4557 0.856436 12.9663 0.367044C12.4769 -0.122348 11.689 -0.122348 11.1996 0.367044L6.66667 4.9L2.13371 0.367044C1.64432 -0.122348 0.856436 -0.122348 0.367044 0.367044C-0.122348 0.856436 -0.122348 1.64432 0.367044 2.13371L4.9 6.66667L0.367044 11.1996C-0.122348 11.689 -0.122348 12.4769 0.367044 12.9663C0.856436 13.4557 1.64432 13.4557 2.13371 12.9663L6.66667 8.43334L11.1996 12.9663C11.689 13.4557 12.4769 13.4557 12.9663 12.9663C13.4522 12.4769 13.4522 11.6855 12.9663 11.1996Z" fill="#1B1918"/>
      </svg>
      <!-- SVG Arrow Left -->
      <svg v-else width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.9141 19.5312L4.88281 12.5L11.9141 5.46875" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M5.85938 12.5H20.1172" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
  </button>
  <div class="d-flex w-100 justify-content-center">
    <span class="DeclarationUBO"> {{ title }}</span>
  </div>
  </div>
</template>

<script>
import '../LMSGstyle.css'

/** @author TLV 10/02/2021
* @brief Component pour afficher les informations des actionnaires
*/
export default {
  name: 'HeaderBack',
  props: {
    canBack: {
      type: Boolean,
      default: false
    },
    isCross: {
      type: Boolean,
      default: false
    },
    onBack: {
      type: Function,
      default: function () {
      }
    },
    title: {
      type: String
    }
  },
  mounted () {
  }
}
</script>
<style>
.buttonBack {
  background-color: white;
  border: none;
  position: absolute;

}
.DeclarationUBO {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  color: #1B1918;
  align-items: center;
  text-align: center;
  max-width: 70%;
}

</style>



// WEBPACK FOOTER //
// HeaderBack.vue?a07e78ae